<p>
  Unauthorized. You are propably logged in with a different microsoft account. Please log out and reload the page.

  <br/>

  <button (click)="onLogoutClick()">Logout</button>
</p>
